import client from './client';

export async function fetchDashboard(params) {
  const { data } = await client.get('/dashboard', { params });
  return data.data;
}
